<template>
  <router-view></router-view>
</template>

<script>
import { useConfigStore } from '@/stores/configStore';

import { mapActions, mapState } from 'pinia'

export default {
	created(){
		this.fetchAndSetAppCode()
		// moved to dashboard navbar
	},
	methods: {
		...mapActions(useConfigStore, ['fetchAndSetAppCode'])
	}	
}
</script>
<style>
.btn-group-vertical > .btn:not(:last-child):not(.dropdown-toggle){
  margin-top: 0.5rem;
  border-radius: 0.25rem;
}
.btn-group-vertical > .btn:not(:first-child){
  margin-top: 0.5rem;
  border-radius: 0.25rem;
}
</style>
